// extracted by mini-css-extract-plugin
export default {"container":"Title_container__ri4GA","count":"Title_count__QP7N+"};